<div class="container resp-container">
  <iframe class="resp-iframe" frameborder="0" style="border:0"
          [src]="safeUrl" allowfullscreen></iframe>
</div>
